var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9.3215mm",
    height: "10.189mm",
    viewBox: "0 0 9.3215 10.189",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient35356",
    x1: 83.26,
    x2: 83.26,
    y1: 91.239,
    y2: 82.895,
    gradientTransform: "matrix(1 0 0 1 3.3403e-5 -.00023953)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdada4",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe8e5",
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80.918 -81.956)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#linearGradient35356)",
    stroke: "#ef2118",
    strokeLinejoin: "round",
    strokeWidth: 1.765,
    "aria-label": 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m87.156 88.162c0.26458-0.03175 0.87841-0.10583 1.5557-0.6985 0.37042-0.32808 0.64558-0.87841 0.64558-1.9579 0-2.5188-1.6298-2.667-3.8312-2.667-3.4713 0-3.5666 1.2171-3.5666 2.9951h1.8627c0.02117-1.0372 0.08467-1.2594 1.8521-1.2594 1.5663 0 1.7992 0.29633 1.7992 1.0372 0 0.70908-0.28575 0.81491-0.89958 0.889l-2.7093 0.3175c-2.0637 0.24342-2.0637 1.9791-2.0637 2.7834v1.6616h7.493v-1.7357h-5.5986v-0.26458c0-0.62442 0.33867-0.71966 0.889-0.78316z",
    strokeLinecap: "square",
    style: {
      paintOrder: "stroke markers fill"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.a1e00212f707227d1c30026478ed1570.svg";
export { ForwardRef as ReactComponent };